<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on">
        <v-btn icon @click="hideUnhidePage()" :loading="hidePageLoading">
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </div>
    </template>
    <span>{{ toolTipText }}</span>
  </v-tooltip>
</template>

<script lang="ts">
  import ClientService from '@/services/client/client';
  import { Page } from '@/store/builder/types';
  import Vue from 'vue';
  import { mapActions, mapGetters } from 'vuex';

  export default Vue.extend({
    name: 'PageReimportButton',
    data() {
      return {
        hidePageLoading: false,
      };
    },
    computed: {
      ...mapGetters('builder', { page: 'getPage' }),
      ...mapGetters('programs', { program: 'getProgram' }),
      programId(): number {
        return this.program.id;
      },
      toolTipText(): string {
        return this.page.isHidden ? 'Show page on program' : 'Hide page from program';
      },
      icon(): string {
        return this.page.isHidden ? 'mdi-eye-off' : 'mdi-eye';
      },
    },
    methods: {
      ...mapActions('builder', {
        savePage: 'savePage',
      }),
      ...mapActions('ui', { showToast: 'showToast' }),
      fetchClient: ClientService.fetchClient,
      async hideUnhidePage() {
        const hide = !this.page.isHidden;
        try {
          this.hidePageLoading = true;
          await this.savePage({
            programId: this.programId,
            page: { ...this.page, isHidden: hide } as Page,
          });

          this.showToast(hide ? 'Page hidden successfully' : 'Page is now visible');
        } catch (error) {
          this.showToast(hide ? 'Failed to hide page' : 'Failed to unhide page');
        } finally {
          this.hidePageLoading = false;
        }
      },
    },
  });
</script>
